import React from 'react'
import classnames from 'classnames'
import styles from './disclosure.module.scss'

/**
 * Controlled accordion.
 * The panel is always in the DOM so the open/close transition can be
 * interrupted and reversed at any point instead of popping in and out.
 */
const Disclosure = (props) =>
{
    const { id, label, openLabel, isOpen, onToggle, className, triggerClassName, panelClassName, children } = props

    return (
        <div className={classnames(styles.disclosure, className, isOpen ? styles.open : null)}>
            <button
                type="button"
                className={classnames(styles.trigger, triggerClassName)}
                aria-expanded={isOpen}
                aria-controls={id}
                onClick={onToggle}
            >
                <svg className={styles.chevron} viewBox="0 0 10 6" aria-hidden="true" focusable="false">
                    <path
                        d="M1 1L5 5L9 1"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className={styles.label}>{ (isOpen && openLabel) ? openLabel : label }</span>
            </button>

            <div
                id={id}
                className={classnames(styles.panel, panelClassName)}
                role="region"
                aria-hidden={!isOpen}
            >
                <div className={styles.panelInner}>
                    { children }
                </div>
            </div>
        </div>
    )
}

export default Disclosure
